// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocPublishResult,
}                               from '../interfaces';
import {
    POST_COLLAB_PUBLISH_MODE,
}                               from '../enums';

const publishPostCollaborativeDoc = async ({
    test,
    docId,
    checkpointId,
    publishMode,
    previewCutoffParagraphId,
    previewCutoffCheckpointId,
}: {
    test: boolean,
    docId: string,
    checkpointId?: string,
    publishMode?: POST_COLLAB_PUBLISH_MODE,
    previewCutoffParagraphId?: string | null,
    previewCutoffCheckpointId?: string | null,
}): Promise<IPostCollabDocPublishResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string | null | undefined>,
        IPostCollabDocPublishResult
    >(
        functions,
        'publishPostCollaborativeDoc',
    );
    return callable({
        test,
        docId,
        checkpointId,
        publishMode,
        previewCutoffParagraphId,
        previewCutoffCheckpointId,
    }).then((result) => result.data as IPostCollabDocPublishResult).catch((err) => {
        throw err;
    });
};

export default publishPostCollaborativeDoc;
